import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { UserContextProvider } from "./store/user-context";

ReactDOM.render(
  <UserContextProvider>
    <App />
  </UserContextProvider>,
  document.getElementById("root")
);
